__turbopack_context__.v({
  "back": "moreLink-module-scss-module__6aQu7q__back",
  "black_fuchsia": "moreLink-module-scss-module__6aQu7q__black_fuchsia",
  "black_green": "moreLink-module-scss-module__6aQu7q__black_green",
  "chevron": "moreLink-module-scss-module__6aQu7q__chevron",
  "fuchsia_background": "moreLink-module-scss-module__6aQu7q__fuchsia_background",
  "initial": "moreLink-module-scss-module__6aQu7q__initial",
  "inner": "moreLink-module-scss-module__6aQu7q__inner",
  "keep_on_mobile": "moreLink-module-scss-module__6aQu7q__keep_on_mobile",
  "link": "moreLink-module-scss-module__6aQu7q__link",
  "mobile_more": "moreLink-module-scss-module__6aQu7q__mobile_more",
  "more": "moreLink-module-scss-module__6aQu7q__more",
  "second": "moreLink-module-scss-module__6aQu7q__second",
  "space": "moreLink-module-scss-module__6aQu7q__space",
  "white_fuchsia": "moreLink-module-scss-module__6aQu7q__white_fuchsia",
  "white_green": "moreLink-module-scss-module__6aQu7q__white_green",
});
